import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import useGetSalaryByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetSalaryByID'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import SalaryCard from 'InstitutionalManagement/components/SalaryCard'
import SearchSalaryOnCustomForm from './components/SearchSalaryOnCustomForm'
import SelectSalaryOnCustomForm from './components/SelectSalaryOnCustomForm'
import { useCustomFormSalarySelectionDrawerManager } from './contexts/CustomFormSalarySelectionDrawerManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormSalarySelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getSalary, loadingSalary } = useGetSalaryByID()

  const { selectedSalary, setSelectedSalary, view, filter } = useCustomFormSalarySelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_SALARY: <SearchSalaryOnCustomForm onClose={onClose} />,
      SELECT_SALARY: <SelectSalaryOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadSalary(salaryId: string) {
    const salaryFromAPI = await getSalary(salaryId)
    setSelectedSalary(salaryFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const salaryId = question.default_value[0]
        await loadSalary(salaryId)
      }
      if (question.answer && question.answer.length > 0) {
        const salaryId = question.answer[0]
        await loadSalary(salaryId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingSalary}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedSalary?.id ? 'Atualizar salário' : 'Adicionar salário'}
      </Button>

      {selectedSalary?.id && <SalaryCard salary={selectedSalary} borderWidth="1px" borderColor="borderColor" />}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormSalarySelectionDrawerContent
